import _slicedToArray from "/opt/buildhome/repo/gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/opt/buildhome/repo/gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classCallCheck from "/opt/buildhome/repo/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/buildhome/repo/gatsby/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/opt/buildhome/repo/gatsby/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/opt/buildhome/repo/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/opt/buildhome/repo/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import sync from 'framesync';
import React__default, { useContext } from 'react';
import { usePresence } from '../../../components/AnimatePresence/use-presence.mjs';
import { LayoutGroupContext } from '../../../context/LayoutGroupContext.mjs';
import { SwitchLayoutGroupContext } from '../../../context/SwitchLayoutGroupContext.mjs';
import { globalProjectionState } from '../../../projection/node/state.mjs';
import { correctBorderRadius } from '../../../projection/styles/scale-border-radius.mjs';
import { correctBoxShadow } from '../../../projection/styles/scale-box-shadow.mjs';
import { addScaleCorrector } from '../../../projection/styles/scale-correction.mjs';
var MeasureLayoutWithContext = /*#__PURE__*/function (_React__default$Compo) {
  _inherits(MeasureLayoutWithContext, _React__default$Compo);
  var _super = _createSuper(MeasureLayoutWithContext);
  function MeasureLayoutWithContext() {
    _classCallCheck(this, MeasureLayoutWithContext);
    return _super.apply(this, arguments);
  }
  _createClass(MeasureLayoutWithContext, [{
    key: "componentDidMount",
    value:
    /**
     * This only mounts projection nodes for components that
     * need measuring, we might want to do it for all components
     * in order to incorporate transforms
     */
    function componentDidMount() {
      var _this = this;
      var _this$props = this.props,
        visualElement = _this$props.visualElement,
        layoutGroup = _this$props.layoutGroup,
        switchLayoutGroup = _this$props.switchLayoutGroup,
        layoutId = _this$props.layoutId;
      var projection = visualElement.projection;
      addScaleCorrector(defaultScaleCorrectors);
      if (projection) {
        if (layoutGroup.group) layoutGroup.group.add(projection);
        if (switchLayoutGroup && switchLayoutGroup.register && layoutId) {
          switchLayoutGroup.register(projection);
        }
        projection.root.didUpdate();
        projection.addEventListener("animationComplete", function () {
          _this.safeToRemove();
        });
        projection.setOptions(_objectSpread(_objectSpread({}, projection.options), {}, {
          onExitComplete: function onExitComplete() {
            return _this.safeToRemove();
          }
        }));
      }
      globalProjectionState.hasEverUpdated = true;
    }
  }, {
    key: "getSnapshotBeforeUpdate",
    value: function getSnapshotBeforeUpdate(prevProps) {
      var _this2 = this;
      var _this$props2 = this.props,
        layoutDependency = _this$props2.layoutDependency,
        visualElement = _this$props2.visualElement,
        drag = _this$props2.drag,
        isPresent = _this$props2.isPresent;
      var projection = visualElement.projection;
      if (!projection) return null;
      /**
       * TODO: We use this data in relegate to determine whether to
       * promote a previous element. There's no guarantee its presence data
       * will have updated by this point - if a bug like this arises it will
       * have to be that we markForRelegation and then find a new lead some other way,
       * perhaps in didUpdate
       */
      projection.isPresent = isPresent;
      if (drag || prevProps.layoutDependency !== layoutDependency || layoutDependency === undefined) {
        projection.willUpdate();
      } else {
        this.safeToRemove();
      }
      if (prevProps.isPresent !== isPresent) {
        if (isPresent) {
          projection.promote();
        } else if (!projection.relegate()) {
          /**
           * If there's another stack member taking over from this one,
           * it's in charge of the exit animation and therefore should
           * be in charge of the safe to remove. Otherwise we call it here.
           */
          sync.postRender(function () {
            var _a;
            if (!((_a = projection.getStack()) === null || _a === void 0 ? void 0 : _a.members.length)) {
              _this2.safeToRemove();
            }
          });
        }
      }
      return null;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var projection = this.props.visualElement.projection;
      if (projection) {
        projection.root.didUpdate();
        if (!projection.currentAnimation && projection.isLead()) {
          this.safeToRemove();
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this$props3 = this.props,
        visualElement = _this$props3.visualElement,
        layoutGroup = _this$props3.layoutGroup,
        promoteContext = _this$props3.switchLayoutGroup;
      var projection = visualElement.projection;
      if (projection) {
        projection.scheduleCheckAfterUnmount();
        if (layoutGroup === null || layoutGroup === void 0 ? void 0 : layoutGroup.group) layoutGroup.group.remove(projection);
        if (promoteContext === null || promoteContext === void 0 ? void 0 : promoteContext.deregister) promoteContext.deregister(projection);
      }
    }
  }, {
    key: "safeToRemove",
    value: function safeToRemove() {
      var safeToRemove = this.props.safeToRemove;
      safeToRemove === null || safeToRemove === void 0 ? void 0 : safeToRemove();
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);
  return MeasureLayoutWithContext;
}(React__default.Component);
function MeasureLayout(props) {
  var _usePresence = usePresence(),
    _usePresence2 = _slicedToArray(_usePresence, 2),
    isPresent = _usePresence2[0],
    safeToRemove = _usePresence2[1];
  var layoutGroup = useContext(LayoutGroupContext);
  return React__default.createElement(MeasureLayoutWithContext, _objectSpread(_objectSpread({}, props), {}, {
    layoutGroup: layoutGroup,
    switchLayoutGroup: useContext(SwitchLayoutGroupContext),
    isPresent: isPresent,
    safeToRemove: safeToRemove
  }));
}
var defaultScaleCorrectors = {
  borderRadius: _objectSpread(_objectSpread({}, correctBorderRadius), {}, {
    applyTo: ["borderTopLeftRadius", "borderTopRightRadius", "borderBottomLeftRadius", "borderBottomRightRadius"]
  }),
  borderTopLeftRadius: correctBorderRadius,
  borderTopRightRadius: correctBorderRadius,
  borderBottomLeftRadius: correctBorderRadius,
  borderBottomRightRadius: correctBorderRadius,
  boxShadow: correctBoxShadow
};
export { MeasureLayout };